/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { MediaFile, MediaFileBundle, MediaRootDetail, MediaRootPermission } from 'elements-sdk'

export interface MediaOperationContext {
  root?: MediaRootDetail
  location?: MediaFile
  permission?: MediaRootPermission
  isSearch?: boolean
}

export interface MediaOperationInput {
  dirs: MediaFile[]
  bundles: MediaFileBundle[]
}

export abstract class BaseOperation {
  id: string
  label: string
  icon: string|null = null
  collapseLabel = true
  showInToolbar = false
  showInSelectionToolbar = false
  showInContextMenu = false
  showInAssetView = false
  showInSharedLinkView = false
  showInAdvancedContextMenu = false
  showInOverflowMenu = false
  showInSelectionOverflowMenu = false
  supportsMultiple = false
  supportsDirs = false
  supportsBundles = false
  triggersReload = false
  weight = 0

  getLabelForDir (dir: MediaFile, context: MediaOperationContext): string {
    return this.label
  }

  getLabelForBundle (bundle: MediaFileBundle, context: MediaOperationContext): string {
    return this.label
  }

  isVisibleFor ({ dirs, bundles }: MediaOperationInput, context: MediaOperationContext): boolean {
    if (!this.supportsMultiple && dirs.length + bundles.length > 1) {
      return false
    }
    return dirs.every(x => this.isVisibleForDir(x, context)) && bundles.every(x => this.isVisibleForBundle(x, context))
  }

  isVisibleForDir (dir: MediaFile, context: MediaOperationContext): boolean {
    return true
  }

  isVisibleForBundle (bundle, context: MediaOperationContext): boolean {
    return true
  }

  isEnabledFor ({ dirs, bundles }: MediaOperationInput, context: MediaOperationContext): boolean {
    return dirs.every(x => this.isEnabledForDir(x, context)) && bundles.every(x => this.isEnabledForBundle(x, context))
  }

  isEnabledForDir (dir: MediaFile, context: MediaOperationContext) {
    return this.supportsDirs
  }

  isEnabledForBundle (bundle: MediaFileBundle, context: MediaOperationContext) {
    return this.supportsBundles
  }

  async run ({ dirs, bundles }: MediaOperationInput, context: MediaOperationContext): Promise<void> {
    await Promise.all([
      ...dirs.map(x => this.runForDir(x, context)),
      ...bundles.map(x => this.runForBundle(x, context)),
    ])
  }

  async runForDir (dir: MediaFile, context: MediaOperationContext) { }

  async runForBundle (bundle: MediaFileBundle, context: MediaOperationContext) { }
}
